import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Image from 'next/image';
import Link from 'next/link';
import { ENDPOINTS } from '@/config/endpoints';
import { ThreeDots } from 'react-loader-spinner';
import { SEODATA } from '@/config/seo_config';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import CategoryDropdown from '@/component/shared/categoriesDrodown';
import Head from 'next/head';
import IMAGES from '@/public/assets/img';
import enIN from '@/locales/common/enIN';
import esMX from '@/locales/common/esMX';

export const metadata = {
  title: SEODATA.CATEGORYLIST.title,
  description1: SEODATA.CATEGORYLIST.description1,
  description2: SEODATA.CATEGORYLIST.description2,
  keywords: SEODATA.CATEGORYLIST.keyword,
  alternates: {
    canonical: SEODATA.CATEGORYLIST.url
  },
  
  openGraph: {
    title: SEODATA.CATEGORYLIST.title,
    description1: SEODATA.CATEGORYLIST.description1,
    description2: SEODATA.CATEGORYLIST.description2,
    url: SEODATA.CATEGORYLIST.url,
  }
};


const Pagination = dynamic(() => import('@/component/shared/pagination'), {
    loading: () => <p>Loading...</p>})
const ResourcesLinks = dynamic(() => import('@/layout/resourcesLinks'), {
      loading: () => <p>Loading...</p>})

const CategoryBlogsPost=({posts,paraUrl,categoryIdNew,categorySlug,currentPageNew,totalPagesNew})=> {
  // const [posts, setPosts] = useState([]);
  const [currentPage, setCurrentPage] = useState(currentPageNew);
  const [totalPages, setTotalPages] = useState(totalPagesNew);
  const [loader,setLoader] = useState(true);
  const router = useRouter();
  const { locale } = router;
  const t = (locale === 'es-mx' && esMX) || (locale === 'en-in' && enIN);
  // const { category } = router.query.category;
  // const categoryId = router;
  // const { id, slug } = router.query;
  const categoryId = router.query.id;
  const slugName= router.query.slug;


  useEffect(() => {
    setCurrentPage(1); // Reset to first page
  }, [categorySlug]);

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      const nextPage = currentPage + 1;
      setCurrentPage(nextPage);
      updatePageQuery(nextPage);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      const prevPage = currentPage - 1;
      setCurrentPage(prevPage);
      updatePageQuery(prevPage);
    }
  };

  const handlePageClick = (page) => {
    setCurrentPage(page);
    updatePageQuery(page);
  };

  const updatePageQuery = (page) => {
    router.push({
      pathname: router.pathname,
      query: { ...router.query, page: page.toString() },
    });
  };
  const dateFormat = (publishDate)=>{
    const dateString = new Date(publishDate);
    const options = { day:'numeric', year: 'numeric', month: 'long' };
    if (typeof dateString === 'object' && dateString !== null && 'toLocaleDateString' in dateString) {
      const result = dateString.toLocaleDateString('en-US',options);
      return <span>{result}</span>
    }
  }
  const dateFormatSpanish = (publishDate)=>{
    const dateString = new Date(publishDate);
    const options = { day:'numeric', year: 'numeric', month: 'long' };
    if (typeof dateString === 'object' && dateString !== null && 'toLocaleDateString' in dateString) {
      const result = dateString.toLocaleDateString('es-MX',options);
      return <span>{result}</span>
    }
  }
  const renderPageNumbers = () => {
    const pageNumbers = [];
    const maxPageDisplay = 5;
  
    // Calculate the start and end page numbers to display
    let startPage = Math.max(1, currentPage - Math.floor(maxPageDisplay / 2));
    let endPage = startPage + maxPageDisplay - 1;
  
    if (endPage > totalPages) {
      endPage = totalPages;
      startPage = Math.max(1, endPage - maxPageDisplay + 1);
    }
  
    // Ensure startPage is within valid range
    if (startPage <= 0) {
      startPage = 1;
    }
  
    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <button
          key={i}
          onClick={() => handlePageClick(i)}
          className={currentPage === i ? 'active' : ''}
        >
          {i}
        </button>
      );
    }
  
    return pageNumbers;
  };
  

  const truncateString=(str, maxLength)=> {
    if (str.length <= maxLength) {
      return str; // No truncation needed
    }
  
    // Truncate the string and append an ellipsis
    const truncatedString = str.slice(0, maxLength - 3) + '...';
    return truncatedString;
  }
  const truncatedTitle=(title)=>{
    const originalString = title;
    const maxLength = 50;
    return truncateString(originalString, maxLength);
  }

  useEffect(() => {
    setLoader(false);
    setTotalPages(totalPagesNew);
  }, [posts, totalPagesNew]);


  const toTitleCase = (str) => {
    return str
      .toLowerCase()
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  // console.log('posts',posts)

  // first Image of post
  const firstImageUrl = posts?.[0]?._embedded?.['wp:featuredmedia']?.[0]?.source_url || posts?.[0].featured_media_url ;

  return (
    <main className='mt-[100px]'>
    
      <Head>  
        <title>{categorySlug + ' Articles - ' + metadata.title}</title>
        <meta name="description" content={metadata.description1 + categorySlug + '.' + metadata.description2 + categorySlug + ' at Credlix.'} />
        <meta name="keywords" content={metadata.keywords} />
        {/* {OpenGraph tags} */}
        <meta property="og:title" content={categorySlug + ' Articles - ' + metadata.openGraph.title}/>
        <meta property="og:description" content={metadata.openGraph.description1 + categorySlug + '.' + metadata.openGraph.description2 + categorySlug + ' at Credlix.'} />
        <meta property="og:url" content={metadata.openGraph.url + paraUrl} />
        <link rel="canonical" href={metadata.alternates.canonical + paraUrl} />
        <link rel='preload' href={firstImageUrl} as="image" />
        {/* <link rel="alternate" hrefLang="es" href={WEB_URL+'/es'+router.asPath}/>
        <link rel="alternate" hreflang="en" href={WEB_URL+router.asPath} /> */}
      </Head>

      <section className='pb-20 pt-10 bg-white sm:py-8'>
          <div className='container  lg:px-3  px-3 xm:px-2'>
            
            <ResourcesLinks />
           {categorySlug && <h1 className='text-lg font-medium mb-2 sm:mt-2'>{categorySlug} Blogs</h1>}
            <div className='flex flex-wrap flex-1'>
            
              <div className="w-[25%] md:w-full sm:w-full md:mt-4 sm:mt-0 sm:pr-0 pr-2 pt-2">
                <div className="lg:sticky xm:sticky lg:top-[135px] xm:top-[100px]">
                    <CategoryDropdown/>
                </div>
              </div>
              <div className="w-[75%] md:w-full sm:w-full">
                {posts.length >0 && 
                <ul className="flex flex-wrap flex-1 -mx-xsp">
                 {posts.map((post,i) => (
                    <li key={post.id} className="w-1/3 md:w-1/2 sm:w-full py-2 px-1 list-none">
                      <div className="bg-white shadow-cardShadow2 border border-[#E6E6E6] min-h-[300px] hover:shadow-cardHover2 transition-shadow animate-fade-in">
                      <Link href={`/blogs/${post.slug}`}>
                      {/* {post._embedded && post._embedded['wp:featuredmedia'] && (
                          <Image className='w-full sm:h-auto' loading='lazy'
                            src={post._embedded['wp:featuredmedia'][0].source_url}
                            alt={post.title.rendered} width={261} height={180}
                          />
                        )} */}
                        {post._embedded && post._embedded['wp:featuredmedia'] ? (
                        <Image
                          className='w-full object-fill min-h-[165px] sm:h-auto'
                          src={post._embedded['wp:featuredmedia'][0].source_url}
                          alt={post.title.rendered}
                          fetchPriority={i === 0?'high':'auto'}
                          width={261}
                          priority={i === 0?true:false} 
                          height={180}
                        />
                      ) : post.featured_media_url ? (
                        <Image
                          className='w-full object-fill min-h-[165px] sm:h-auto'
                          src={post.featured_media_url}
                          alt={post.title.rendered}
                          fetchPriority={i === 0?'high':'auto'}
                          width={261}
                          priority={i === 0?true:false} 
                          height={180}
                        />
                      ) : null}

                      </Link> 
                      
                        <div className="px-2 pt-3">
                              <Link href={`/blogs/${post.slug}`}>
                              <p className='text-xs text-[#7b7b7b]'>{locale == 'es-mx' ? dateFormatSpanish(post.date) :  dateFormat(post.date)}</p>
                              <h3 className="text-sm text-secondary my-1 mb-3 min-h-[40px]" dangerouslySetInnerHTML={{ __html: truncatedTitle(post.title.rendered) }} />
                              <div className='flex items-end justify-between mb-1'>
                              <button className="flex item-center text-brand text-xs">
                                  Read More
                                  <span className="ml-1">
                                  <svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18"><path d="M16.1716 10.9999L10.8076 5.63589L12.2218 4.22168L20 11.9999L12.2218 19.778L10.8076 18.3638L16.1716 12.9999H4V10.9999H16.1716Z" fill="rgba(2,43,92,1)"></path>
                                  </svg>
                                  </span>
                                </button>
                              </div>
                              </Link>
                              {/* {post._embedded && post._embedded['wp:term'] && (
                              <div className='mb-3'>
                                {
                                post._embedded['wp:term'][0].map(category => (
                                  category.name != 'Blog' && category.name != 'Spanish Blog' && 
                                  <Link key={category.id} className='text-[12px] text-brand bg-[#ddd] rounded-md py-[3px] px-[5px] hover:underline' href={`/blogs/category/${category.id}/${category.slug}`}>{toTitleCase(category.name)}</Link>
                                ))}
                              </div>
                            )} */}
                          {post.category_names && post.category_names.length > 0 && (
                              <div className="mb-3">
                                {post.category_names.map((name, index) => (
                                  name !== 'Blog' && name !== 'Spanish Blog' && (
                                    <span
                                      key={index}
                                      className="text-[12px] text-brand bg-[#ddd] rounded-md py-[3px] px-[5px] mr-1"
                                    >
                                      {toTitleCase(name)}
                                    </span>
                                  )
                                ))}
                              </div>
                            )}

                          </div>                              
                      </div>
                    </li>
                  ))}
                </ul>
                // :
                //   <p className='text-xxl text-center py-20'> No Posts Found</p>
                }
              </div>
            </div>
          </div>
        </section>
        {!loader && 
        <Pagination pageNumbers={renderPageNumbers()} handlePrevPage={handlePrevPage} handleNextPage={handleNextPage} currentPage={currentPage} totalPages={totalPages}/>
        }
        {loader &&
        <div className='fixed inset-0 z-[9999] items-center flex bg-[rgba(255,255,255,0.8)]'>
          <div className='w-[100px] mx-auto h-[100px] justify-center flex'>
          <ThreeDots 
            height="80" 
            width="80" 
            radius="9"
            color="#032B5C" 
            ariaLabel="three-dots-loading"
            wrapperStyle={{}}
            wrapperClassName="m-auto"
            visible={true}
            />
            </div>
          </div>
      }
    </main>
  );
}

export default CategoryBlogsPost;


export async function getServerSideProps(context) {
  const locale = context.locale;
  let postData = [];
  let totalPagesNew = 1;
  const { page } = context.query;
  const currentPageNew = parseInt(page, 10) || 1;
  const paraUrl = context.resolvedUrl.replace(/\?page=\d*$/, '') || null;
  const parts = paraUrl.split('/');
  const categoryIdNew = parts[3]; 
  const categorytitle = parts[4];
  const categorySlug = categorytitle.split("-").map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(" ");

  try {
    const baseUrl = ENDPOINTS.WORDPRESS_BLOG_POST_CATEGORY_LIST;
    const perPage = 12;
    const langParam = locale === 'es-mx' ? `&lang=es` : '';
    const apiUrl = `${baseUrl}categories=${categoryIdNew}&per_page=${perPage}&page=${currentPageNew}${langParam}`;
    // console.log('API URL:', apiUrl);
    const res = await fetch(apiUrl);
     // If API fails or category doesn't exist → return 404
    if (!res.ok) {
      return { notFound: true };
    }
   const data = await res.json();
    if (!data || data.length === 0) {
      return { notFound: true };
    }
    const categoryMap = {};


    // Get total pages from headers
    totalPagesNew = parseInt(res.headers.get('x-wp-totalpages'), 10) || 1;

    // For posts missing _embedded featured image, fetch manually using featured_media
    const enhancedPosts = await Promise.all(data.map(async (post) => {
      // if (!post._embedded || !post._embedded['wp:featuredmedia']) {
        if (post.featured_media) {
          try {
            const mediaRes = await fetch(ENDPOINTS.WORDPRESS_MEDIA+'/'+post.featured_media);
            const mediaData = await mediaRes.json();
            post.featured_media_url = mediaData.source_url;
          } catch (mediaErr) {
            console.error('Media Fetch Error:', mediaErr);
          }
        }
        if(post.categories && post.categories.length > 0){
          const categoryIds = post.categories;
          // Fetch categories in bulk
          const categoryRes = await fetch(`${ENDPOINTS.WORDPRESS_CAT_WITH_CATSLUG}?include=${categoryIds.join(',')}${langParam}`);
          const categoryData = await categoryRes.json();
          categoryData.forEach(cat => {
            categoryMap[cat.id] = cat.name;
          });
        }
       
         // Map categories to names
      post.category_names = post.categories.map(catId => categoryMap[catId] || 'Unknown');

      return post;
    }));
    

    postData = enhancedPosts;
  } catch (error) {
    console.error('Fetch Error:', error);
  }

  return {
    props: {
      posts: postData,
      totalPagesNew,
      paraUrl,
      categoryIdNew,
      currentPageNew,
      categorySlug,
    },
  };
}



